import { BaseComponent } from '../../components/base-component'
import { CartPage } from './cart'
import { replaceNodeChildren } from '../../utils/dom'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CART_PAGE_SELECTOR = 'cart-page'
const CHECKOUT_BUTTON_SELECTOR = '[data-cart-page-checkout-button]'

export class CartButtonsBlock extends BaseComponent {
  mountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.on('start-update', this.handleStartCartUpdate)
    cart?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cart: CartPage = $elParent(CART_PAGE_SELECTOR, this)
    cart?.off('start-update', this.handleStartCartUpdate)
    cart?.off('update-nodes', this.handleCartUpdate)
  }

  handleStartCartUpdate = (): void => {
    this.setLoading(true)
  }

  handleCartUpdate = ({ node }): void => {
    this.setLoading(false)
    replaceNodeChildren(
      this,
      $el(
        `cart-buttons-block[block-id="${this.getAttribute('block-id')}"]`,
        node,
      ),
    )
  }

  setLoading(isLoading: boolean): void {
    const button = $el(CHECKOUT_BUTTON_SELECTOR, this)
    button?.toggleAttribute('disabled', isLoading)
    button?.classList.toggle('loading', isLoading)
  }
}
